var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popover-dawn-wapper"},[_c('es-icon',{staticClass:"popover-icon",attrs:{"name":"exclamation-circle-filled","size":"14"}}),_vm._v(_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }